import React from "react";
import { Link } from "react-router-dom";

const SearchFilterBtn = () => {
  const filterOptions = [
    {
      fName: "All",
      link: "/restaurant",
    },
    {
      fName: "High To Low",
      link: "/sorted/htl",
    },
    {
      fName: "Low To High",
      link: "/sorted/lth",
    },
    {
      fName: "A-Z",
      link: "/sorted/az",
    },
    {
      fName: "Z-A",
      link: "/sorted/za",
    },
  ];
  return (
    <div className="position-sticky w-100 top-0 bg-white z-3">
      <div className="container">
        <div className="d-flex">
          {filterOptions.map((data) => {
            return (
              <div className="btn-group my-3" key={data.link}>
                <Link to={data.link}>
                  <button
                    className="btn btn-outline-secondary ms-4 btn-sm fbtnMobile"
                    type="button"
                    aria-expanded="false"
                  >
                    {data.fName}
                  </button>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SearchFilterBtn;
